import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1b486f1a&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style1 from "./Index.vue?vue&type=style&index=1&id=1b486f1a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b486f1a",
  null
  
)

export default component.exports